import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
import { LoginByReReDocument } from './schema.graphql';
import { LoginByReMutation, LoginByReMutationVariable } from 'src/app/model/login-re';


@Injectable({
  providedIn: 'root'
})
export class LoginByReGQL extends Apollo.Mutation<LoginByReMutation, LoginByReMutationVariable> {
  document = LoginByReReDocument;
  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
